/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import * as _ from "lodash";
import { APP_COMPONENTS } from "../index";

@Component({
  selector: "my-tabs",
  templateUrl: "./tabs.component.html",
})
export class TabsComponent implements AfterContentInit {
  dynamicTabs = [];
  instance_id: 0;
  menus = [];
  user: any;
  menulist = [];
  calcIn = "";
  @ViewChild("container", { read: ViewContainerRef }) dynamicTabPlaceholder;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver) {}
  ngAfterContentInit() {}
  doCalc($event) {
    let a = this.calcIn;
    if (a[a.length - 1] == "=") {
      this.calcIn = eval(a.substr(0, a.length - 1));
    }
  }

  setData(menus, menulist, user) {
    this.menus = menus;
    this.menulist = menulist;
    this.user = user;
  }

  openTab(tabObj: any) {
    let menus = this.menus;
    let user = this.user;
    let tabInd = _.findIndex(this.dynamicTabs, { tabID: tabObj["title"] });
    if (tabInd == -1 || tabObj["instance"] == "MULTIPLE") {
      let component = _.find(APP_COMPONENTS, { name: tabObj["name"] });
      let componentFactory = this._componentFactoryResolver.resolveComponentFactory(
        component
      );
      let viewContainerRef = this.dynamicTabPlaceholder;
      let componentRef = viewContainerRef.createComponent(componentFactory);
      let instance = componentRef.instance;
      instance.instance_id = ++this.instance_id;
      if (tabObj.params == undefined) {
        tabObj.params = {};
      }
      instance.title =
        tabObj["params"]["tabTitle"] || tabObj["title"] || tabObj["name"];
      instance.tabID = tabObj["title"] || tabObj["name"];
      instance.menu = tabObj;
      instance.user = this.user;

      if (tabObj.params) {
        instance.params = tabObj.params;
      }

      if (instance.tabUpdateEvent) {
        instance.tabUpdateEvent.subscribe(($e) => {
          this.childTabListeners($e);
        });
      }
      this.dynamicTabs.push(componentRef.instance);

      tabInd = this.dynamicTabs.length - 1;
    }
    this.selectTab(this.dynamicTabs[tabInd]);
  }
  selectTab(tab: any) {
    if (tab) {
      this.dynamicTabs.forEach((tab) => (tab.active = false));
      tab.active = true;
    } else {
      tab = this.dynamicTabs[this.dynamicTabs.length - 1];
      if (tab) tab.active = true;
    }
  }

  closeTab(tab: any) {
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        this.dynamicTabs.splice(i, 1);
        let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        let tab = this.dynamicTabs[this.dynamicTabs.length - 1];
        this.selectTab(tab);
        break;
      }
    }
  }

  closeActiveTab() {
    let activeTabs = this.dynamicTabs.filter((tab) => tab.active);
    if (activeTabs.length > 0) {
      this.closeTab(activeTabs[0]);
    }
  }

  closeAllTab() {
    let tabs = this.dynamicTabs,
      tabLen = tabs.length;
    for (let i = 0; i < tabLen; i++) {
      let tab = tabs[i] ? tabs[i] : tabs[0];
      this.closeTab(tab);
    }
  }

  getChildMenu(tabName, menus) {
    for (let i = 0; i < menus.length; i++) {
      if (menus[i].menu_name == tabName || menus[i].title == tabName) {
        return menus[i];
      }
      let a = this.getChildMenu(tabName, menus[i].children);
      if (a) {
        return a;
      }
    }
    return false;
  }

  childTabListeners(params: any) {
    let action = params.action;
    if (action == "NewTab") {
      let tabParams = params.params,
        tabParent = tabParams.tabParent,
        tabName = tabParams.tabName,
        title = tabParams.title,
        tabMenu = this.getChildMenu(tabName, this.menus);
      if (tabMenu) {
        tabMenu.name = tabMenu.component;
        tabMenu["params"] = tabParams;
        this.openTab(tabMenu);
      } else {
        let fallbackMenu = {
          name: tabParams.name,
          component: tabParams.name,
          title: title,
          menu_name: tabName,
          instance: "MULTIPLE",
          children: [],
          params: tabParams
        };
        this.openTab(fallbackMenu);
      }
    } else if (action == "CloseTab") {
      this.closeActiveTab();
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/home/tabs.component.ts